export const mogg = {
    bg: '#131621',
    blue: '#0677E8',
    grayBg: '#292C35',
    grayText: '#ACADB9'
}